'use client'

/**
 * Shared context for the HOME HONEST_REVIEWS widget-of-widget pair.
 *
 * HONEST_REVIEWS is the container: it owns the section-level values the non-PL `HonestReviewsV2`
 * forks close over per card — the section tracker, type/id and tracking metadata — and arranges
 * the pre-rendered SINGLE_REVIEW_CARD children. The section publishes those values here, bound
 * per-card with the card's position (`productPosition` in click/wishlist events); each card widget
 * reads its slot and builds the exact per-card track configs the non-PL forks build inline
 * (mirrors `influencer-v2-card-context`).
 */

import { createContext, useContext } from 'react'

import type { TrackingMetaData } from '@src/quince-site-common/src/domains/CustomSection'

export interface ReviewCardContextValue {
  /** The card's position within the section's visible review list (drives `productPosition`). */
  index: number
  /**
   * Section tracker (`'home_page'` on home, matching the non-PL SectionRenderer). Required —
   * an optional tracker let `undefined__click_product_carousel` labels ship (PR 7150 review).
   */
  tracker: string
  sectionType: string
  sectionId: string
  trackingMetaData: TrackingMetaData
}

const ReviewCardContext = createContext<ReviewCardContextValue | null>(null)

export const ReviewCardContextProvider = ReviewCardContext.Provider

export const useReviewCardContext = (): ReviewCardContextValue | null => useContext(ReviewCardContext)
